import styled from 'vue-styled-components';

import { COLORS, GRAY } from '@styles/common.styled';
import {
    FLEX_COLUMN_DIV,
    FLEX_VERTICAL_CENTER_DIV,
} from '@/styles/common.styled.component';

export const Wrapper = styled(FLEX_COLUMN_DIV)`
    gap: 12px;

    .option-title {
        border-bottom: unset;
    }
`;

export const EmptyContentWrapper = styled.div`
    height: 0px;
    background: white;
`;

export const ContentWrapper = styled.div`
    max-height: 320px;
    padding: 16px;
    overflow-y: auto;
    background: white;
    border-top: 1px solid ${GRAY(20)};
`;

export const FilterWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    flex-flow: row wrap;
    gap: 8px;
    height: fit-content;
    max-height: 150px;
    padding: 9px 16px;
    overflow-y: scroll;
    background: ${COLORS['white']};
    border: 1px solid ${GRAY(20)};
    border-top: none;
    border-radius: 0 0 2px 2px;
    &::-webkit-scrollbar {
        width: 6px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${COLORS['gray-25']};
    }
`;

export const Title = styled.span`
    padding-right: 4px;
    font-size: 13px;
    font-weight: 500;
    color: ${GRAY(50)};
`;

export const FilterItem = styled(FLEX_VERTICAL_CENTER_DIV)`
    padding: 6px 11px;
    background: ${GRAY(25)};
    border-radius: 12px;
    word-break: break-word;
    font-size: 12px;
    font-weight: 400;
    color: ${GRAY(60)};
`;
